import { Pipe, PipeTransform } from '@angular/core';
import { isNotEmpty } from '@app/utils';

@Pipe({
    name: 'tooltipText',
    pure: true,
    standalone: false
})

/*
Pure pipe to calculate tooltips based on marketing plan locked status. If the marketing plan is locked,
it will return the second string in the array, or return null.
Otherwise, it returns the first string in the array.
 */
export class TooltipTextPipe implements PipeTransform {
  transform(locked: boolean, text: string[]): string {
    if (locked) {
      if (isNotEmpty(text[1])) {
        return text[1];
      } else {
        return null;
      }
    } else {
      return text[0];
    }
  }
}
